import { Blueprint } from '@/components/builder/base/blueprints/Blueprint';
import { HasWidth } from '@/components/builder/base/traits/HasWidth';
import { BlueprintDefinition } from '@/components/builder/details/blueprints/BlueprintDefinition';
import { VisibleBlueprint } from '@/components/builder/form/blueprints/VisibleBlueprint';
import { AlwaysChoice } from '@/components/builder/form/enums/AlwaysChoice';
import { WhenChoice } from '@/components/builder/form/enums/WhenChoice';

export const Definition: BlueprintDefinition = {
    type: 'comments',
    name: '[[[Komentarze]]]',
    icon: 'fa-message-quote',
    group: 'functionalities',
    position: 2,
};

export interface CommentsContract extends Blueprint, VisibleBlueprint, HasWidth {
    maxAttachments: number;
    maxAttachmentSizeMb: number;
}

export class CommentsType implements CommentsContract
{
    public id: string;
    public type: string;
    public name: string;
    public width: number;
    public minWidth: number;
    public visible: AlwaysChoice | WhenChoice;
    public visibleWhen: string;
    public maxAttachments: number;
    public maxAttachmentSizeMb: number;

    public constructor(id: string, name: string)
    {
        this.id = id;
        this.type = Definition.type;
        this.name = name;
        this.width = 0;
        this.minWidth = 2;
        this.visible = AlwaysChoice.Always;
        this.visibleWhen = null;
        this.maxAttachments = 2;
        this.maxAttachmentSizeMb = 10;
    }

    public setDefaultWidth(width: number): void
    {
        this.width = width;
    }
}
